import { globalHistory } from '@reach/router'
import { navigate } from 'gatsby-link'
import Cookies from 'js-cookie'
import { isBrowser, logout } from '../services/auth'

// 型定義
interface Location {
    origin: string
    pathname: string
    href: string
}

interface LogoutHandlerOptions {
    cb?: () => void
}

const IS_DEBUG = false

// リダイレクトパスの設定
const setRedirectPath = (location: Location): void => {
    let redirectPath = location.pathname

    const currentRedirectPath = Cookies.get("connect_redirect")?.toString()
    if (!currentRedirectPath && (
        redirectPath.match(/404/g) || 
        redirectPath.match(/500/g) || 
        !redirectPath.match(/\/member/g)
    )) {
        redirectPath = "/member/"
    }
}

// 登録ハンドラー
const registerHandler = (): void => {
    const { location } = globalHistory
    
    if (IS_DEBUG) {
        navigate('/member/')
        return
    }
    
    const url = location.href.replace(/\?.*$/, "")
    if (isBrowser()) {
        window.location.href = `${process.env.GATSBY_MODD_URL_REGISTER}${url}`
    }
}

// ログインハンドラー
const loginHandler = (isBlank?: boolean): void => {
    const { location } = globalHistory
    
    if (IS_DEBUG) {
        window.open('/member/', '_blank')
        return
    }
    
    // URLパラメータが含まれていたら削除
    setRedirectPath(location)

    const url = `${location.origin}/connect/`
    if (isBrowser()) {
        if (!isBlank) {
            window.location.href = `${process.env.GATSBY_MODD_URL_LOGIN}${url}`
        } else {
            window.open(`${process.env.GATSBY_MODD_URL_LOGIN}${url}`, '_blank')
        }
    }
}

// クリックログインハンドラー
const clickLoginHandler = (isBlank?: boolean): void => {
    const { location } = globalHistory
    
    if (IS_DEBUG) {
        window.open('/member/', '_blank')
        return
    }
    
    Cookies.set("logined", 'true', { path: "/", expires: 30/86400 }) // 3分
    console.log("pathname", location.pathname)
    setRedirectPath(location)
    
    const url = `${location.origin}/connect/`
    if (isBrowser()) {
        if (!isBlank) {
            window.location.href = `${process.env.GATSBY_MODD_URL_LOGIN}${url}`
        } else {
            window.open(`${process.env.GATSBY_MODD_URL_LOGIN}${url}`, '_blank')
        }
    }
}

// ログアウトハンドラー
const logoutHandler = ({ cb }: LogoutHandlerOptions): void => {
    if (IS_DEBUG) {
        navigate('/')
        return
    }
    
    Cookies.remove("logined")
    Cookies.remove("connect_redirect")
    
    logout({
        callback: () => {
            if (cb) {
                cb()
            }
            if (isBrowser()) {
                window.location.href = `${process.env.GATSBY_MODD_URL_LOGOUT}`
            }
        }
    })
}

export { loginHandler, clickLoginHandler, registerHandler, logoutHandler }